import { set } from "date-fns";

import { ContactDetailResponse, ContactDetailType } from "@/api";

/**
 * The contact the backend will notify: the client's first *stored* entry of that kind, blanks
 * skipped. This must stay the same pick as `ClientPrimaryContacts` server-side, or the dialog shows
 * an address the notification never goes to. Entry ids are uuidv7, whose text form sorts
 * chronologically, so the comparison is a plain ordinal one on the id — the personal-data response's
 * own order is descending and must not be relied on here.
 */
export function firstStoredContact(contactDetails: ContactDetailResponse[], type: ContactDetailType): string | null {
  return (
    [...contactDetails]
      .filter((cd) => cd.type === type && cd.value.trim() !== "")
      .sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0))[0]?.value ?? null
  );
}

/**
 * Combines the day picked in a DatePicker with the time picked in a TimePicker into the single
 * instant the API expects. Seconds and milliseconds are dropped — the pickers only offer minutes,
 * so carrying the sub-minute remainder of whichever `new Date()` seeded them would be noise.
 */
export function combineDayAndTime(day: Date, time: Date): Date {
  return set(day, {
    hours: time.getHours(),
    minutes: time.getMinutes(),
    seconds: 0,
    milliseconds: 0,
  });
}
